import React, { useState } from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import AllMarathonQuestions from "@jumbo/Dashboards/Tests/MarathonQuestions";
import { useRouteMatch } from "react-router-dom";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import { Button, Typography } from "@material-ui/core";
import AddBatchQuesttionsDialog from "@jumbo/Dashboards/Tests/MarathonQuestions/AddBatchQuesttionsDialog";
import TestSelectOption from "@jumbo/Dashboards/Tests/compnents/TestSelectOption";

const categoryOptions = [
  {
    optName: "کتاب شناسی و فرهنگ مطالعه",
    value: "کتاب شناسی و فرهنگ مطالعه",
  },
  {
    optName: "ایران شناسی و هویت ملی",
    value: "ایران شناسی و هویت ملی",
  },
  {
    optName: "بهره وری در کار و صنعت",
    value: "بهره وری در کار و صنعت",
  },
  {
    optName: "مذهبی، اخلاقی و احکام روزمره",
    value: "مذهبی، اخلاقی و احکام روزمره",
  },
  {
    optName: "خانواده، تربیت و سبک زندگی فرهنگی",
    value: "خانواده، تربیت و سبک زندگی فرهنگی",
  },
  {
    optName: "تاریخ ایران و جهان",
    value: "تاریخ ایران و جهان",
  },
  {
    optName: "علم، طبیعت و دانش عمومی",
    value: "علم، طبیعت و دانش عمومی",
  },
  {
    optName: "هنری و ورزشی",
    value: "هنری و ورزشی",
  },
  {
    optName: "سوال طلایی",
    value: "سوال طلایی",
  },
];

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.marathonEveventsPage"} />, link: "/tests" },
  { label: <IntlMessages id={"pages.questionsPage"} />, isActive: "true" },
];

const MarathonEventQuestions = () => {
  const [category, setCategory] = useState(categoryOptions[0].value);
  const { params } = useRouteMatch();
  const [
    openAddBatchQuestionsDialog,
    setOpenAddBatchQuestionsDialog,
  ] = useState(false);
  return (
    <PageContainer
      heading={<IntlMessages id="pages.marathonEventQuestionsPage" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <div
            style={{
              marginBottom: 10,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <IntlMessages id="pages.marathonEventQuestionsPage.description" />
            <div>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<AddToPhotosIcon />}
                onClick={() => setOpenAddBatchQuestionsDialog(true)}
                style={{ marginBlock: "10px" }}
              >
                اضافه کردن گروهی
              </Button>
            </div>
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <Typography variant="h4" gutterBottom align="center" style={{marginBottom:'20px'}}>
              سوالات آزمون : {params.eventName}
            </Typography>

            <TestSelectOption
              title={" دسته بندی سوال"}
              value={category}
              handleChange={(value) => setCategory(value)}
              options={categoryOptions}
            />
            <AllMarathonQuestions id={params.id} category={category} />
          </div>
        </Grid>
      </GridContainer>
      <AddBatchQuesttionsDialog
        open={openAddBatchQuestionsDialog}
        handleClose={() => setOpenAddBatchQuestionsDialog(false)}
        eventId={params.id}
      />
    </PageContainer>
  );
};

export default MarathonEventQuestions;
